import React,{useState} from 'react';

import {getRanking} from '../store/storeRanking';
import {parseTimeToString} from '../Utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faClock, faPuzzlePiece, faTrophy} from '@fortawesome/free-solid-svg-icons';

import Select from './select/Select';

import './Rank.css';

const Rank = () => {
    const games = ['geral','causa','sintomas','transmissao','prevencao','vacinas'];
    const temas = ['Geral','Causa','Sintomas','Transmissão','Prevenção','Vacinas'];
    const [game, setGame] = useState("geral");

    const handleSelectGame = (option) => {
        const id = temas.indexOf(option) || 0;
        setGame(games[id]);
    };

    return(
        <div className = "rank">
            <div className="head row nowrap spaceAroundContent centerItens">
                <span className="title colorEIC3 strokeText">Rank</span>
                <Select values  = {temas} handler = {handleSelectGame}/>
            </div>
            <table className = "content">
                <thead className = "head">
                    <tr>
                        <th><FontAwesomeIcon icon = {faTrophy}/></th>
                        <th><FontAwesomeIcon icon = {faUsers}/></th>
                        <th><FontAwesomeIcon icon = {faClock}/></th>
                        <th><FontAwesomeIcon icon = {faPuzzlePiece}/></th>
                    </tr>
                </thead>
                <tbody>
                    {getRanking(game).map((player, i) => 
                        <tr key = {i}> 
                            <th>{i+1}º</th> 
                            <th>{player.name}</th>
                            <th>{parseTimeToString(player.timeout)}</th>
                            <th>{player.moves}</th>
                        </tr>
                    )}
                </tbody>
            </table>
            
        </div>
    );
};

export default Rank;